var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockchainDt(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 160,
    viewBox: "0 0 198 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M197.494 0H0.5V160H197.494V0Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M116.336 112.459H116.827",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M117.812 112.459H144.373L155.145 123.231H166.241",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10,
    strokeDasharray: "0.99 0.99"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M166.734 123.231H167.225",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M111.766 91.8894H136.867L159.393 69.3638V58.2632",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M105.523 74.2613V45.8611H126.418L138.659 33.6208V20.0693",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M81.6589 112.46H53.6201L42.8438 123.232H30.7656",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2286 91.8894H61.1271L38.6016 69.3638V58.2632",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10,
    strokeDasharray: "0.98 0.98"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M92.4632 74.2613V45.8611H71.5731L59.3281 33.6208V20.0693",
    stroke: "#120096",
    strokeWidth: 0.491096,
    strokeMiterlimit: 10
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9076 117.382L32.1905 119.504L26.4688 117.382L32.3248 115.667L37.9076 117.382Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6865 117.382L32.1932 118.679L28.6953 117.382L32.2766 116.334L35.6865 117.382Z",
    fill: "#C7C8CA"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9046 117.381L32.1875 119.503V126.161L37.9046 123.807V117.381Z",
    fill: "#F48000",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4688 117.381L32.1905 119.503V126.161L26.4688 123.807V117.381Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5873 117.382L20.8655 119.504L15.1484 117.382L21.0045 115.667L26.5873 117.382Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3662 117.382L20.8683 118.679L17.375 117.382L20.9563 116.334L24.3662 117.382Z",
    fill: "#C7C8CA"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.5889 117.381L20.8672 119.503V126.161L26.5889 123.807V117.381Z",
    fill: "#F48000",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1484 117.381L20.8655 119.503V126.161L15.1484 123.807V117.381Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2748 109.231L26.5577 111.353L20.8359 109.231L26.692 107.517L32.2748 109.231Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0537 109.255L26.5604 110.552L23.0625 109.255L26.6438 108.208L30.0537 109.255Z",
    fill: "#C7C8CA"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2718 109.231L26.5547 111.353V117.394L32.2718 115.657V109.231Z",
    fill: "#F48000",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8359 109.231L26.5577 111.353V117.394L20.8359 115.657V109.231Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.291878,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M74.3575 74.3594H123.643C126.882 74.3594 129.509 76.9863 129.509 80.2247V110.107C129.509 113.346 126.882 115.973 123.643 115.973H74.3575C71.1191 115.973 68.4922 113.346 68.4922 110.107V80.2247C68.4922 76.9863 71.1191 74.3594 74.3575 74.3594Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.463298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M123.48 77.9175H71.9609V112.419H123.48V77.9175Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.463298,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M126.452 87.8086C126.874 87.8086 127.216 88.1514 127.216 88.573V101.768C127.216 102.189 126.874 102.532 126.452 102.532C126.03 102.532 125.688 102.189 125.688 101.768V88.573C125.688 88.1514 126.03 87.8086 126.452 87.8086Z",
    fill: "#221531"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123.48 109.854H71.9609V112.42H123.48V109.854Z",
    fill: "#C7C8CA"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123.48 77.9185H71.9609V80.4851H123.48V77.9185Z",
    fill: "#C7C8CA"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M180.493 71.1826H164.352V80.8702H180.493V71.1826Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M180.493 76.895H164.352V80.8747H180.493V76.895Z",
    fill: "#C7C8CA"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M174.901 73.4522C174.817 73.4939 174.711 73.5125 174.576 73.5125C174.4 73.5125 174.266 73.4615 174.164 73.3596C174.062 73.2577 174.016 73.1187 174.016 72.9472C174.016 72.7666 174.071 72.6183 174.182 72.5025C174.294 72.3913 174.442 72.3311 174.623 72.3311C174.734 72.3311 174.826 72.345 174.905 72.3728V72.6183C174.831 72.572 174.743 72.5488 174.646 72.5488C174.539 72.5488 174.451 72.5812 174.386 72.6507C174.321 72.7202 174.289 72.8083 174.289 72.9241C174.289 73.0399 174.321 73.1233 174.382 73.1882C174.442 73.253 174.525 73.2854 174.632 73.2854C174.738 73.2854 174.822 73.2623 174.905 73.2113V73.4476L174.901 73.4522Z",
    fill: "white"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M176.056 73.4942H175.759L175.583 73.2023C175.583 73.2023 175.556 73.1606 175.546 73.1421C175.532 73.1236 175.523 73.1097 175.509 73.0958C175.495 73.0819 175.486 73.0726 175.472 73.068C175.458 73.0633 175.444 73.0587 175.426 73.0587H175.356V73.4942H175.102V72.3545H175.509C175.787 72.3545 175.926 72.4564 175.926 72.6649C175.926 72.7066 175.922 72.739 175.908 72.7761C175.894 72.8085 175.88 72.841 175.857 72.8688C175.834 72.8966 175.806 72.9197 175.778 72.9382C175.746 72.9568 175.713 72.9753 175.671 72.9846C175.671 72.9846 175.704 73.0031 175.722 73.0124C175.736 73.0263 175.755 73.0402 175.769 73.0541C175.783 73.068 175.797 73.0865 175.81 73.105C175.824 73.1236 175.838 73.1421 175.847 73.1606L176.061 73.4988L176.056 73.4942ZM175.356 72.5491V72.8688H175.468C175.523 72.8688 175.565 72.8502 175.602 72.8224C175.634 72.79 175.653 72.7483 175.653 72.702C175.653 72.6047 175.593 72.5537 175.472 72.5537H175.356V72.5491Z",
    fill: "white"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M176.85 73.4942H176.164V72.3545H176.822V72.563H176.424V72.8178H176.794V73.0263H176.424V73.2857H176.85V73.4942Z",
    fill: "white"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M177.023 73.4942V72.3545H177.427C177.83 72.3545 178.033 72.5398 178.033 72.9104C178.033 73.0865 177.978 73.2301 177.867 73.3367C177.755 73.4432 177.607 73.4942 177.427 73.4942H177.023ZM177.283 72.563V73.2857H177.408C177.519 73.2857 177.607 73.2533 177.672 73.1838C177.737 73.1189 177.765 73.0263 177.765 72.9104C177.765 72.8039 177.732 72.7159 177.672 72.6556C177.607 72.5954 177.519 72.563 177.408 72.563H177.283Z",
    fill: "white"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M178.582 72.3545V72.5537H178.485V73.295H178.582V73.4942H178.133V73.295H178.23V72.5537H178.133V72.3545H178.582Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M179.549 72.563H179.224V73.4942H178.965V72.563H178.641V72.3545H179.549V72.563Z",
    fill: "white"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M179.571 73.8188H165.273V73.9393H179.571V73.8188Z",
    fill: "white"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M165.273 77.3438V78.4788H166.126V77.3438H165.273ZM165.941 78.275H165.459V77.5476H165.941V78.275Z",
    fill: "white"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M166.383 77.3438V78.4788H167.235V77.3438H166.383ZM167.05 78.275H166.568V77.5476H167.05V78.275Z",
    fill: "white"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M167.484 77.3438V78.4788H168.337V77.3438H167.484ZM168.152 78.275H167.67V77.5476H168.152V78.275Z",
    fill: "white"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M169.695 77.3438V78.4788H170.548V77.3438H169.695ZM170.362 78.275H169.881V77.5476H170.362V78.275Z",
    fill: "white"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M170.805 77.3438V78.4788H171.657V77.3438H170.805ZM171.472 78.275H170.99V77.5476H171.472V78.275Z",
    fill: "white"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M171.914 77.3438V78.4788H172.767V77.3438H171.914ZM172.581 78.275H172.099V77.5476H172.581V78.275Z",
    fill: "white"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M173.023 77.3438V78.4788H173.876V77.3438H173.023ZM173.691 78.275H173.209V77.5476H173.691V78.275Z",
    fill: "white"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M174.125 77.3438V78.4788H174.977V77.3438H174.125ZM174.792 78.275H174.31V77.5476H174.792V78.275Z",
    fill: "white"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M176.336 77.3438V78.4788H177.188V77.3438H176.336ZM177.003 78.275H176.521V77.5476H177.003V78.275Z",
    fill: "white"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M177.445 77.3438V78.4788H178.298V77.3438H177.445ZM178.112 78.275H177.631V77.5476H178.112V78.275Z",
    fill: "white"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M178.555 77.3438V78.4788H179.407V77.3438H178.555ZM179.222 78.275H178.74V77.5476H179.222V78.275Z",
    fill: "white"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M177.982 78.8413H165.273V79.2629H177.982V78.8413Z",
    fill: "white"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M171.644 79.5264H165.273V79.948H171.644V79.5264Z",
    fill: "white"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M167.94 75.1571H167.189V75.1062H167.926C167.87 74.9625 167.731 74.8652 167.569 74.8652H166.758V75.2359H166.707V74.8652H166.615V75.2359H166.564V74.8652H165.883V75.3749H167.954V75.2451C167.954 75.2127 167.954 75.1849 167.944 75.1571H167.94Z",
    fill: "white"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M165.653 76.6859H166.08V76.4635H166.131V76.6859H166.344V76.4635H166.395V76.6859H167.571V76.3384H165.273C165.292 76.533 165.454 76.6859 165.653 76.6859Z",
    fill: "white"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M166.714 75.4263H165.273V75.6764H166.131V75.7274H165.273V75.871H166.131V75.922H165.273V76.061H166.131V76.1119H165.273V76.288H166.714V75.4263Z",
    fill: "white"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M167.586 75.4263H166.766V76.288H167.586V75.4263Z",
    fill: "white"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M165.831 74.8652H165.65C165.437 74.8652 165.266 75.0367 165.266 75.2498V75.3795H165.826V74.8699L165.831 74.8652Z",
    fill: "white"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M167.957 75.8896H167.633V76.2881H167.957V75.8896Z",
    fill: "white"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M167.625 76.6815C167.801 76.6583 167.94 76.5147 167.954 76.334H167.625V76.6815Z",
    fill: "white"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M167.957 75.4263H167.633V75.8386H167.957V75.4263Z",
    fill: "white"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7272 26.3247H12.5859V36.0123H28.7272V26.3247Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M28.7272 32.0371H12.5859V36.0168H28.7272V32.0371Z",
    fill: "#C7C8CA"
  }))), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M23.1427 28.5968C23.0593 28.6385 22.9528 28.657 22.8184 28.657C22.6423 28.657 22.508 28.606 22.4061 28.5041C22.3041 28.4022 22.2578 28.2632 22.2578 28.0918C22.2578 27.9111 22.3134 27.7628 22.4246 27.647C22.5358 27.5358 22.684 27.4756 22.8647 27.4756C22.9759 27.4756 23.0686 27.4895 23.1473 27.5173V27.7628C23.0732 27.7165 22.9852 27.6933 22.8879 27.6933C22.7813 27.6933 22.6933 27.7258 22.6285 27.7953C22.5636 27.8648 22.5312 27.9528 22.5312 28.0686C22.5312 28.1844 22.5636 28.2678 22.6238 28.3327C22.684 28.3976 22.7674 28.43 22.874 28.43C22.9806 28.43 23.064 28.4068 23.1473 28.3559V28.5921L23.1427 28.5968Z",
    fill: "white"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2981 28.6334H24.0016L23.8256 28.3415C23.8256 28.3415 23.7978 28.2998 23.7885 28.2813C23.7746 28.2627 23.7654 28.2488 23.7515 28.2349C23.7376 28.221 23.7283 28.2118 23.7144 28.2071C23.7005 28.2025 23.6866 28.1979 23.6681 28.1979H23.5986V28.6334H23.3438V27.4937H23.7515C24.0294 27.4937 24.1684 27.5956 24.1684 27.8041C24.1684 27.8458 24.1638 27.8828 24.1499 27.9153C24.136 27.9477 24.1221 27.9801 24.0989 28.0079C24.0758 28.0357 24.048 28.0589 24.0202 28.0774C23.9877 28.0959 23.9553 28.1145 23.9136 28.1237C23.9136 28.1237 23.946 28.1423 23.9646 28.1515C23.9831 28.1608 23.997 28.1793 24.0109 28.1932C24.0248 28.2118 24.0387 28.2257 24.0526 28.2442C24.0665 28.2627 24.0804 28.2813 24.0897 28.2998L24.3028 28.638L24.2981 28.6334ZM23.5986 27.6882V28.0033H23.7098C23.7654 28.0033 23.807 27.9847 23.8441 27.957C23.8765 27.9245 23.8951 27.8828 23.8951 27.8365C23.8951 27.7392 23.8348 27.6882 23.7144 27.6882H23.5986Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0919 28.6334H24.4062V27.4937H25.0641V27.7021H24.6657V27.957H25.0363V28.1654H24.6657V28.4249H25.0919V28.6334Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2656 28.6334V27.4937H25.6687C26.0718 27.4937 26.2756 27.679 26.2756 28.0496C26.2756 28.2257 26.22 28.3693 26.1088 28.4758C25.9976 28.5824 25.8494 28.6334 25.6687 28.6334H25.2656ZM25.5251 27.7021V28.4249H25.6502C25.7614 28.4249 25.8494 28.3925 25.9142 28.323C25.9791 28.2581 26.0069 28.1654 26.0069 28.0496C26.0069 27.9431 25.9745 27.855 25.9142 27.7948C25.8494 27.7346 25.7614 27.7021 25.6502 27.7021H25.5251Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M26.8244 27.4937V27.6929H26.7271V28.4341H26.8244V28.6334H26.375V28.4341H26.4723V27.6929H26.375V27.4937H26.8244Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7909 27.7021H27.4666V28.6334H27.2071V27.7021H26.8828V27.4937H27.7909V27.7021Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27.813 28.957H13.5156V29.0775H27.813V28.957Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5156 32.4878V33.6229H14.3681V32.4878H13.5156ZM14.1828 33.4144H13.7009V32.687H14.1828V33.4144Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M14.625 32.4878V33.6229H15.4775V32.4878H14.625ZM15.2921 33.4144H14.8103V32.687H15.2921V33.4144Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7266 32.4878V33.6229H16.579V32.4878H15.7266ZM16.3937 33.4144H15.9119V32.687H16.3937V33.4144Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9375 32.4878V33.6229H18.79V32.4878H17.9375ZM18.6046 33.4144H18.1228V32.687H18.6046V33.4144Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0469 32.4878V33.6229H19.8993V32.4878H19.0469ZM19.714 33.4144H19.2322V32.687H19.714V33.4144Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M20.1562 32.4878V33.6229H21.0087V32.4878H20.1562ZM20.8234 33.4144H20.3416V32.687H20.8234V33.4144Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2656 32.4878V33.6229H22.1181V32.4878H21.2656ZM21.9328 33.4144H21.4509V32.687H21.9328V33.4144Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3672 32.4878V33.6229H23.2197V32.4878H22.3672ZM23.0343 33.4144H22.5525V32.687H23.0343V33.4144Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5781 32.4878V33.6229H25.4306V32.4878H24.5781ZM25.2453 33.4144H24.7634V32.687H25.2453V33.4144Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6875 32.4878V33.6229H26.54V32.4878H25.6875ZM26.3547 33.4144H25.8728V32.687H26.3547V33.4144Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7969 32.4878V33.6229H27.6493V32.4878H26.7969ZM27.464 33.4144H26.9822V32.687H27.464V33.4144Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2239 33.979H13.5156V34.4006H26.2239V33.979Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M19.886 34.6646H13.5156V35.0862H19.886V34.6646Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M16.182 30.2958H15.4315V30.2448H16.1681C16.1125 30.1012 15.9736 30.0039 15.8114 30.0039H15.0006V30.3745H14.9497V30.0039H14.857V30.3745H14.806V30.0039H14.125V30.5135H16.1959V30.3838C16.1959 30.3514 16.1959 30.3236 16.1867 30.2958H16.182Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8955 31.8245H14.3218V31.6021H14.3727V31.8245H14.5858V31.6021H14.6368V31.8245H15.8136V31.4771H13.5156C13.5342 31.6716 13.6963 31.8245 13.8955 31.8245Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9565 30.5649H13.5156V30.8151H14.3727V30.8661H13.5156V31.0097H14.3727V31.0607H13.5156V31.1997H14.3727V31.2506H13.5156V31.4267H14.9565V30.5649Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8279 30.5649H15.0078V31.4267H15.8279V30.5649Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M14.073 30.0039H13.8923C13.6792 30.0039 13.5078 30.1753 13.5078 30.3884V30.5182H14.0684V30.0085L14.073 30.0039Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1993 31.0283H15.875V31.4268H16.1993V31.0283Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8672 31.8245C16.0432 31.8014 16.1822 31.6577 16.1961 31.4771H15.8672V31.8245Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1993 30.5649H15.875V30.9773H16.1993V30.5649Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M40.86 132.458H37.5938V137.11H40.86V132.458Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0319 129.817H41.7656V137.109H45.0319V129.817Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1959 127.176H45.9297V137.109H49.1959V127.176Z",
    fill: "#E49A4D",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M177.071 18.9023H173.805V23.5539H177.071V18.9023Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M181.243 16.2612H177.977V23.5535H181.243V16.2612Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M185.407 13.6206H182.141V23.5537H185.407V13.6206Z",
    fill: "#E49A4D",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M28.6829 79.1768H20.0285C19.4605 79.1768 19 79.6372 19 80.2053V86.659C19 87.2271 19.4605 87.6875 20.0285 87.6875H28.6829C29.251 87.6875 29.7115 87.2271 29.7115 86.659V80.2053C29.7115 79.6372 29.251 79.1768 28.6829 79.1768Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7068 80.4369V80.2053C29.7068 79.6354 29.2435 79.1768 28.6783 79.1768H20.0285C19.4587 79.1768 19 79.6401 19 80.2053V80.4369H29.7115H29.7068Z",
    fill: "#E49A4D",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M28.94 79.8528C28.94 80.0521 28.7779 80.2096 28.5833 80.2096C28.3887 80.2096 28.2266 80.0474 28.2266 79.8528C28.2266 79.6583 28.3887 79.4961 28.5833 79.4961C28.7779 79.4961 28.94 79.6583 28.94 79.8528Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7538 79.853C27.7538 79.9827 27.6473 80.0893 27.5175 80.0893C27.3878 80.0893 27.2812 79.9827 27.2812 79.853C27.2812 79.7233 27.3878 79.6167 27.5175 79.6167C27.6473 79.6167 27.7538 79.7233 27.7538 79.853Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0819 79.853C27.0819 79.9827 26.9754 80.0893 26.8457 80.0893C26.7159 80.0893 26.6094 79.9827 26.6094 79.853C26.6094 79.7233 26.7159 79.6167 26.8457 79.6167C26.9754 79.6167 27.0819 79.7233 27.0819 79.853Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4101 79.853C26.4101 79.9827 26.3035 80.0893 26.1738 80.0893C26.0441 80.0893 25.9375 79.9827 25.9375 79.853C25.9375 79.7233 26.0441 79.6167 26.1738 79.6167C26.3035 79.6167 26.4101 79.7233 26.4101 79.853Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M26.1728 82.8743L26.0477 83.4488H25.4593L25.2832 84.2411H25.9411L25.7975 84.8156H25.1628L24.9126 85.9182H24.2732L24.5049 84.8156H23.7729L23.5366 85.9182H22.8973L23.1243 84.8156H22.5312L22.6471 84.2411H23.2447L23.4115 83.4488H22.7675L22.8741 82.8743H23.5273L23.7636 81.7393H24.4169L24.1806 82.8743H24.9126L25.1535 81.7393H25.8021L25.5659 82.8743H26.1542H26.1728ZM24.8107 83.4488H24.0694L23.8933 84.2411H24.63L24.8107 83.4488Z",
    fill: "#221531"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M116.363 25.437H107.708C107.14 25.437 106.68 25.8975 106.68 26.4655V32.9193C106.68 33.4873 107.14 33.9478 107.708 33.9478H116.363C116.931 33.9478 117.391 33.4873 117.391 32.9193V26.4655C117.391 25.8975 116.931 25.437 116.363 25.437Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M117.394 26.6972V26.4655C117.394 25.8957 116.931 25.437 116.366 25.437H107.716C107.146 25.437 106.688 25.9003 106.688 26.4655V26.6972H117.399H117.394Z",
    fill: "#E49A4D",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M116.628 26.1131C116.628 26.3123 116.465 26.4698 116.271 26.4698C116.076 26.4698 115.914 26.3077 115.914 26.1131C115.914 25.9185 116.076 25.7563 116.271 25.7563C116.465 25.7563 116.628 25.9185 116.628 26.1131Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M115.441 26.1132C115.441 26.243 115.335 26.3495 115.205 26.3495C115.075 26.3495 114.969 26.243 114.969 26.1132C114.969 25.9835 115.075 25.877 115.205 25.877C115.335 25.877 115.441 25.9835 115.441 26.1132Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M114.762 26.1132C114.762 26.243 114.655 26.3495 114.525 26.3495C114.396 26.3495 114.289 26.243 114.289 26.1132C114.289 25.9835 114.396 25.877 114.525 25.877C114.655 25.877 114.762 25.9835 114.762 26.1132Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M114.09 26.1132C114.09 26.243 113.983 26.3495 113.853 26.3495C113.724 26.3495 113.617 26.243 113.617 26.1132C113.617 25.9835 113.724 25.877 113.853 25.877C113.983 25.877 114.09 25.9835 114.09 26.1132Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M113.852 29.1331L113.727 29.7076H113.139L112.963 30.4999H113.621L113.477 31.0743H112.842L112.592 32.177H111.953L112.185 31.0743H111.453L111.216 32.177H110.577L110.804 31.0743H110.211L110.327 30.4999H110.924L111.091 29.7076H110.447L110.554 29.1331H111.207L111.443 27.998H112.097L111.86 29.1331H112.592L112.833 27.998H113.482L113.246 29.1331H113.834H113.852ZM112.495 29.7076H111.754L111.578 30.4999H112.314L112.495 29.7076Z",
    fill: "#221531"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M132.931 121.597V118.572C132.931 117.636 133.69 116.881 134.622 116.881C135.553 116.881 136.313 117.641 136.313 118.572V121.597H137.29V118.572C137.29 117.099 136.095 115.903 134.622 115.903C133.148 115.903 131.953 117.099 131.953 118.572V121.597H132.931Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M138.063 121.319H131.188V128.195H138.063V121.319Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M138.063 121.319H131.188V122.501H138.063V121.319Z",
    fill: "#C7C8CA"
  }))), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M135.53 126.254L135.011 124.572C135.206 124.447 135.336 124.225 135.336 123.975C135.336 123.581 135.016 123.261 134.622 123.261C134.228 123.261 133.913 123.581 133.913 123.975C133.913 124.225 134.043 124.443 134.238 124.572L133.719 126.254H135.53Z",
    fill: "#221531"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M79.8447 24.3453V21.32C79.8447 20.3887 80.6046 19.6289 81.5358 19.6289C82.467 19.6289 83.2268 20.3887 83.2268 21.32V24.3453H84.2044V21.32C84.2044 19.8467 83.0091 18.6514 81.5358 18.6514C80.0625 18.6514 78.8672 19.8467 78.8672 21.32V24.3453H79.8447Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9769 24.0669H78.1016V30.9422H84.9769V24.0669Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.231649,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M84.9769 24.0669H78.1016V25.2483H84.9769V24.0669Z",
    fill: "#C7C8CA"
  }))), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M82.4443 29.0017L81.9254 27.3199C82.12 27.1948 82.2497 26.9724 82.2497 26.7223C82.2497 26.3285 81.93 26.0088 81.5362 26.0088C81.1424 26.0088 80.8274 26.3285 80.8274 26.7223C80.8274 26.9724 80.9571 27.1902 81.1517 27.3199L80.6328 29.0017H82.4443Z",
    fill: "#221531"
  }))), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M190.07 110.905H159.641V129.173H190.07V110.905Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M190.07 121.672H159.641V129.173H190.07V121.672Z",
    fill: "#C7C8CA"
  }))), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M179.529 115.187C179.371 115.261 179.167 115.303 178.913 115.303C178.584 115.303 178.324 115.206 178.134 115.011C177.944 114.816 177.852 114.557 177.852 114.237C177.852 113.895 177.958 113.617 178.171 113.399C178.384 113.186 178.658 113.079 178.996 113.079C179.204 113.079 179.385 113.107 179.529 113.158V113.626C179.385 113.538 179.223 113.496 179.038 113.496C178.834 113.496 178.672 113.561 178.551 113.686C178.426 113.811 178.366 113.983 178.366 114.2C178.366 114.418 178.426 114.571 178.542 114.696C178.658 114.821 178.815 114.881 179.014 114.881C179.214 114.881 179.376 114.835 179.533 114.742V115.182L179.529 115.187Z",
    fill: "white"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M181.704 115.261H181.148L180.814 114.71C180.791 114.668 180.763 114.631 180.745 114.599C180.722 114.566 180.698 114.539 180.675 114.515C180.652 114.492 180.629 114.474 180.601 114.46C180.573 114.446 180.55 114.441 180.518 114.441H180.388V115.266H179.906V113.116H180.675C181.199 113.116 181.458 113.311 181.458 113.7C181.458 113.774 181.449 113.844 181.426 113.908C181.403 113.973 181.37 114.029 181.329 114.08C181.287 114.131 181.236 114.177 181.176 114.21C181.115 114.247 181.051 114.274 180.976 114.298C181.009 114.312 181.041 114.33 181.069 114.353C181.097 114.376 181.129 114.404 181.157 114.432C181.185 114.46 181.213 114.492 181.236 114.529C181.264 114.562 181.287 114.599 181.305 114.631L181.713 115.266L181.704 115.261ZM180.383 113.478V114.075H180.592C180.694 114.075 180.777 114.043 180.842 113.987C180.907 113.927 180.939 113.853 180.939 113.76C180.939 113.57 180.828 113.478 180.601 113.478H180.383Z",
    fill: "white"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M183.194 115.262H181.906V113.112H183.143V113.506H182.388V113.983H183.092V114.377H182.388V114.868H183.194V115.262Z",
    fill: "white"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M183.539 115.262V113.112H184.299C185.063 113.112 185.443 113.459 185.443 114.159C185.443 114.492 185.337 114.761 185.133 114.96C184.924 115.16 184.646 115.262 184.299 115.262H183.539ZM184.021 113.51V114.872H184.262C184.47 114.872 184.637 114.812 184.758 114.682C184.878 114.557 184.938 114.386 184.938 114.168C184.938 113.964 184.878 113.802 184.762 113.686C184.646 113.57 184.48 113.51 184.262 113.51H184.026H184.021Z",
    fill: "white"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M186.46 113.116V113.491H186.28V114.891H186.46V115.266H185.617V114.891H185.798V113.491H185.617V113.116H186.46Z",
    fill: "white"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M188.288 113.51H187.676V115.266H187.19V113.51H186.578V113.116H188.288V113.51Z",
    fill: "white"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M188.325 115.868H161.375V116.095H188.325V115.868Z",
    fill: "white"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M161.375 122.52V124.66H162.983V122.52H161.375ZM162.635 124.276H161.727V122.905H162.635V124.276Z",
    fill: "white"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M163.461 122.52V124.66H165.069V122.52H163.461ZM164.716 124.276H163.808V122.905H164.716V124.276Z",
    fill: "white"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M165.547 122.52V124.66H167.155V122.52H165.547ZM166.802 124.276H165.894V122.905H166.802V124.276Z",
    fill: "white"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M169.719 122.52V124.66H171.326V122.52H169.719ZM170.979 124.276H170.071V122.905H170.979V124.276Z",
    fill: "white"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M171.805 122.52V124.66H173.412V122.52H171.805ZM173.06 124.276H172.152V122.905H173.06V124.276Z",
    fill: "white"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M173.891 122.52V124.66H175.498V122.52H173.891ZM175.146 124.276H174.238V122.905H175.146V124.276Z",
    fill: "white"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M175.977 122.52V124.66H177.584V122.52H175.977ZM177.237 124.276H176.329V122.905H177.237V124.276Z",
    fill: "white"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M178.062 122.52V124.66H179.67V122.52H178.062ZM179.323 124.276H178.415V122.905H179.323V124.276Z",
    fill: "white"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M182.234 122.52V124.66H183.842V122.52H182.234ZM183.49 124.276H182.582V122.905H183.49V124.276Z",
    fill: "white"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M184.32 122.52V124.66H185.928V122.52H184.32ZM185.58 124.276H184.672V122.905H185.58V124.276Z",
    fill: "white"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M186.414 122.52V124.66H188.022V122.52H186.414ZM187.67 124.276H186.762V122.905H187.67V124.276Z",
    fill: "white"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M185.337 125.342H161.375V126.135H185.337V125.342Z",
    fill: "white"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M173.384 126.634H161.375V127.427H173.384V126.634Z",
    fill: "white"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M166.418 118.396H165.001V118.299H166.386C166.279 118.03 166.02 117.84 165.714 117.84H164.19V118.539H164.093V117.84H163.917V118.539H163.819V117.84H162.531V118.803H166.437V118.563C166.437 118.507 166.428 118.447 166.418 118.396Z",
    fill: "white"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M162.101 121.278H162.902V120.861H163V121.278H163.403V120.861H163.5V121.278H165.719V120.62H161.383C161.415 120.99 161.726 121.278 162.101 121.278Z",
    fill: "white"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M164.095 118.9H161.375V119.373H162.992V119.47H161.375V119.734H162.992V119.832H161.375V120.096H162.992V120.193H161.375V120.522H164.095V118.9Z",
    fill: "white"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M165.73 118.9H164.188V120.522H165.73V118.9Z",
    fill: "white"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M162.436 117.84H162.098C161.699 117.84 161.375 118.164 161.375 118.563V118.803H162.436V117.84Z",
    fill: "white"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M166.44 119.776H165.828V120.522H166.44V119.776Z",
    fill: "white"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M165.812 121.273C166.146 121.227 166.406 120.958 166.438 120.62H165.812V121.273Z",
    fill: "white"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M166.44 118.9H165.828V119.679H166.44V118.9Z",
    fill: "white"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M152.539 53.6927L161.768 48.3647L170.992 53.6927V64.3485L161.768 69.6718L152.539 64.3485V53.6927Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.504995,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M167.623 53.3831C167.623 49.5841 164.542 46.5032 160.743 46.5032C160.766 46.48 158.848 46.5124 158.829 46.5032C156.207 47.4761 153.867 50.4227 153.867 53.3831C153.867 56.6077 156.564 59.5172 159.556 60.2585C159.561 60.2353 160.173 60.2585 160.747 60.2585C164.546 60.2585 167.627 57.1775 167.627 53.3831H167.623Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M161.648 47.4624H164.312",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M162.625 48.1709H165.289",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M163.602 48.876H165.997",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 49.5845H166.501",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 50.3623H166.904",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 51.1362H167.307",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 51.9097H167.446",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 52.688H167.58",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 53.4619H167.613",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 54.2407H167.543",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 55.0146H167.446",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 55.7881H167.14",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 56.5664H166.802",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M164.578 57.3398H166.366",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M163.875 58.0811H165.663",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M163.164 58.8223H164.952",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M162.453 59.5635H163.871",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M166.504 53.3833C166.504 49.5519 163.4 46.4478 159.568 46.4478C155.737 46.4478 152.633 49.5519 152.633 53.3833C152.633 57.2148 155.737 60.3189 159.568 60.3189C163.4 60.3189 166.504 57.2148 166.504 53.3833Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M165.31 53.3836C165.31 50.21 162.739 47.6387 159.565 47.6387C156.392 47.6387 153.82 50.21 153.82 53.3836C153.82 56.5572 156.392 59.1285 159.565 59.1285C162.739 59.1285 165.31 56.5572 165.31 53.3836Z",
    fill: "#C7C8CA"
  }))), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M161.809 53.7675C161.513 53.4618 161.119 53.2811 160.623 53.2208V53.2023C161.017 53.0911 161.341 52.8965 161.596 52.6139C161.851 52.3313 161.976 52.0024 161.976 51.6271C161.976 51.1082 161.768 50.7098 161.351 50.4225C161.263 50.3623 161.17 50.3113 161.068 50.265V48.7686H159.497V49.9917H159.002V48.7686H157.431V49.9917H157.023V56.955H157.431V57.9928H159.002V56.955H159.497V57.9928H161.068V56.7002C161.253 56.6168 161.42 56.5195 161.568 56.3991C162.022 56.0238 162.254 55.5188 162.254 54.8795C162.254 54.444 162.106 54.0733 161.809 53.7675ZM160.327 51.919C160.327 52.1923 160.234 52.4101 160.049 52.5676C159.863 52.7251 159.609 52.8039 159.284 52.8039H158.594V51.1545H159.182C159.947 51.1545 160.327 51.4094 160.327 51.9236V51.919ZM158.594 55.8061V53.9714H159.451C159.812 53.9714 160.095 54.0502 160.299 54.2077C160.503 54.3652 160.605 54.5829 160.605 54.8609C160.605 55.1389 160.503 55.3798 160.294 55.5512C160.09 55.718 159.803 55.8061 159.442 55.8061H158.594Z",
    fill: "white"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.197 43.5718L157.008 46.3377L159.774 47.1484L157.008 47.9592L156.197 50.7205L155.391 47.9592L152.625 47.1484L155.391 46.3377L156.197 43.5718Z",
    fill: "white"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M156.197 45.1934L156.642 46.7037L158.152 47.1485L156.642 47.5886L156.197 49.1036L155.757 47.5886L154.242 47.1485L155.757 46.7037L156.197 45.1934Z",
    fill: "white"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M156.037 59.7343L165.382 58.9467L170.992 53.6929V64.3487L161.768 69.672L152.539 64.3487L156.037 59.7343Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.393803,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M51.4081 59.9009C51.4081 52.3538 45.2925 46.2336 37.7454 46.2336C37.7917 46.1873 33.9834 46.2568 33.9417 46.2336C28.7343 48.1656 24.0781 54.0216 24.0781 59.9009C24.0781 66.3037 29.4339 72.0856 35.378 73.5636C35.3872 73.5172 36.6011 73.5636 37.7454 73.5636C45.2925 73.5636 51.4081 67.4434 51.4081 59.9009Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5312 48.1333H44.8221",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4766 49.5415H46.7674",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M43.4219 50.9502H48.1753",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 52.3535H49.177",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 53.8965H49.9831",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 55.4346H50.7846",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 56.9775H51.0533",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 58.5205H51.322",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 60.0586H51.3869",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 61.6016H51.2525",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 63.1396H51.0533",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 64.6826H50.451",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 66.2202H49.7839",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M45.3594 67.7627H48.9082",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9531 69.2368H47.502",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M42.5469 70.71H46.0957",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M41.1406 72.1831H43.9575",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1742 59.9006C49.1742 52.2886 43.0077 46.1221 35.3957 46.1221C27.7837 46.1221 21.6172 52.2886 21.6172 59.9006C21.6172 67.5125 27.7837 73.679 35.3957 73.679C43.0077 73.679 49.1742 67.5125 49.1742 59.9006Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.537426,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8143 59.9005C46.8143 53.595 41.7041 48.4849 35.4032 48.4849C29.1024 48.4849 23.9922 53.595 23.9922 59.9005C23.9922 66.206 29.1024 71.3116 35.4032 71.3116C41.7041 71.3116 46.8143 66.2014 46.8143 59.9005Z",
    fill: "#C7C8CA"
  }))), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8443 60.6699C39.2559 60.063 38.4683 59.7016 37.4861 59.5765V59.5395C38.2691 59.3217 38.9177 58.9326 39.418 58.372C39.923 57.8114 40.1778 57.1581 40.1778 56.4122C40.1778 55.3837 39.7609 54.5868 38.9316 54.0216C38.7602 53.9058 38.5702 53.8038 38.371 53.7112V50.7368H35.253V53.1691H34.2615V50.7368H31.1435V53.1691H30.3281V67.0032H31.1435V69.0603H34.2615V67.0032H35.253V69.0603H38.371V66.4936C38.737 66.3314 39.0706 66.1322 39.3671 65.8913C40.2751 65.15 40.7292 64.1447 40.7292 62.8752C40.7292 62.0089 40.4327 61.2722 39.8443 60.6699ZM36.8977 56.996C36.8977 57.5427 36.7124 57.9735 36.3417 58.2839C35.9711 58.5944 35.4661 58.7519 34.8221 58.7519H33.4508V55.4717H34.6183C36.1333 55.4717 36.8931 55.9813 36.8931 56.996H36.8977ZM33.4508 64.7099V61.0637H35.1603C35.8784 61.0637 36.4437 61.2213 36.8421 61.5363C37.2452 61.8513 37.4444 62.2868 37.4444 62.8382C37.4444 63.3895 37.2405 63.8713 36.8328 64.2095C36.4251 64.5431 35.8599 64.7099 35.1418 64.7099H33.4554H33.4508Z",
    fill: "white"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.7039 40.4102L30.3116 45.9002L35.8017 47.5079L30.3116 49.1202L28.7039 54.6102L27.0916 49.1202L21.6016 47.5079L27.0916 45.9002L28.7039 40.4102Z",
    fill: "white"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M28.7074 43.625L29.5877 46.6272L32.5898 47.5074L29.5877 48.3877L28.7074 51.3945L27.8271 48.3877L24.8203 47.5074L27.8271 46.6272L28.7074 43.625Z",
    fill: "white"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M70.0464 21.4518C70.0464 19.6264 68.6658 18.1253 66.896 17.9261C67.2203 17.3933 67.4056 16.7632 67.4056 16.0914C67.4056 14.1317 65.8165 12.5426 63.8568 12.5426C63.1618 12.5426 62.5086 12.7464 61.9619 13.0939C60.9009 11.148 58.8346 9.82764 56.4626 9.82764C53.0017 9.82764 50.1988 12.6306 50.1988 16.0914C50.1988 16.8049 50.3192 17.4906 50.537 18.1299C49.1934 18.6349 48.2344 19.9322 48.2344 21.4518C48.2344 23.2818 49.6243 24.7875 51.4033 24.9775V24.996H67.0257V24.959C68.7353 24.7041 70.0464 23.2309 70.0464 21.4518Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.347474,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M67.52 18.0513C66.7231 18.5655 65.778 18.8667 64.7588 18.8806C64.0592 20.933 62.1133 22.4063 59.8246 22.4063C58.2124 22.4063 56.7715 21.6743 55.8171 20.5253C55.7522 20.5253 55.6874 20.5299 55.6225 20.5299C53.547 20.5299 51.6891 19.6172 50.4197 18.1764C49.141 18.7138 48.2422 19.974 48.2422 21.4472C48.2422 23.2773 49.6321 24.783 51.4111 24.9729V24.9915H67.0336V24.9544C68.7431 24.6996 70.0543 23.2263 70.0543 21.4472C70.0543 19.8442 68.9887 18.4868 67.5247 18.0513H67.52Z",
    fill: "#C7C8CA"
  }))), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M60.702 23.519H57.5933C57.4986 23.519 57.4219 23.5958 57.4219 23.6905V24.1862C57.4219 24.2809 57.4986 24.3576 57.5933 24.3576H60.702C60.7967 24.3576 60.8734 24.2809 60.8734 24.1862V23.6905C60.8734 23.5958 60.7967 23.519 60.702 23.519Z",
    fill: "#FE9339"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6938 23.6902V24.1813H57.5897V23.6902H60.6938ZM60.6938 23.3428H57.5897C57.3997 23.3428 57.2422 23.5003 57.2422 23.6902V24.1813C57.2422 24.3713 57.3997 24.5288 57.5897 24.5288H60.6938C60.8837 24.5288 61.0412 24.3713 61.0412 24.1813V23.6902C61.0412 23.5003 60.8837 23.3428 60.6938 23.3428Z",
    fill: "#221531"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M60.702 24.333H57.5933C57.4986 24.333 57.4219 24.4098 57.4219 24.5044V25.0002C57.4219 25.0948 57.4986 25.1716 57.5933 25.1716H60.702C60.7967 25.1716 60.8734 25.0948 60.8734 25.0002V24.5044C60.8734 24.4098 60.7967 24.333 60.702 24.333Z",
    fill: "#FE9339"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M60.6938 24.5042V24.9953H57.5897V24.5042H60.6938ZM60.6938 24.1567H57.5897C57.3997 24.1567 57.2422 24.3143 57.2422 24.5042V24.9953C57.2422 25.1853 57.3997 25.3428 57.5897 25.3428H60.6938C60.8837 25.3428 61.0412 25.1853 61.0412 24.9953V24.5042C61.0412 24.3143 60.8837 24.1567 60.6938 24.1567Z",
    fill: "#221531"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5926 23.3932C57.4953 23.3932 57.4212 23.3144 57.4212 23.2171V20.757H55.3132C55.253 20.757 55.1927 20.7246 55.1649 20.669C55.1325 20.6134 55.1325 20.5485 55.1649 20.4929L58.9733 13.84C59.0057 13.7844 59.0613 13.752 59.1215 13.752C59.1817 13.752 59.242 13.7844 59.2698 13.84L63.1337 20.4929C63.1661 20.5485 63.1661 20.6134 63.1337 20.669C63.1012 20.7246 63.0456 20.757 62.9808 20.757H60.8728V23.2171C60.8728 23.3144 60.794 23.3932 60.7014 23.3932H57.5973H57.5926Z",
    fill: "#FE9339"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1156 13.9278L62.9795 20.5807H60.6954V23.2123H57.5913V20.5807H55.3073L59.1156 13.9278ZM59.1156 13.5803C58.9905 13.5803 58.8746 13.6452 58.8144 13.7564L55.0061 20.4093C54.9459 20.5159 54.9459 20.6502 55.0061 20.7568C55.0663 20.8634 55.1822 20.9282 55.3073 20.9282H57.2438V23.2123C57.2438 23.4022 57.4014 23.5598 57.5913 23.5598H60.6954C60.8854 23.5598 61.0429 23.4022 61.0429 23.2123V20.9282H62.9795C63.1046 20.9282 63.2204 20.8634 63.2806 20.7522C63.3408 20.6456 63.3408 20.5113 63.2806 20.4047L59.4167 13.7471C59.3565 13.6405 59.2407 13.5757 59.1156 13.5757V13.5803Z",
    fill: "#221531"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M134.206 21.1361V12.9636C134.206 10.4432 136.254 8.39544 138.775 8.39544C141.295 8.39544 143.343 10.4432 143.343 12.9636V21.1361H145.979V12.9636C145.979 8.98846 142.745 5.75928 138.775 5.75928C134.804 5.75928 131.57 8.9931 131.57 12.9636V21.1361H134.206Z",
    fill: "white",
    stroke: "#221531",
    strokeWidth: 0.560591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M148.057 20.3857H129.492V38.9501H148.057V20.3857Z",
    fill: "#FE9339",
    stroke: "#221531",
    strokeWidth: 0.560591,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M148.057 20.3857H129.492V23.5732H148.057V20.3857Z",
    fill: "#C7C8CA"
  }))), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M141.227 33.701L139.828 29.1653C140.356 28.8225 140.703 28.2295 140.703 27.5577C140.703 26.4967 139.842 25.6396 138.785 25.6396C137.729 25.6396 136.867 26.4967 136.867 27.5577C136.867 28.2295 137.215 28.8225 137.743 29.1653L136.344 33.701H141.236H141.227Z",
    fill: "#221531"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainDt);
export default __webpack_public_path__ + "static/media/blockchain_DT.f82ddc6c971bf5354e90c2611008b0c9.svg";
export { ForwardRef as ReactComponent };